module.exports = __webpack_public_path__ + "img/sublogo.4b662640.png";